<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row align-content-center mb-3">
        <div class="col-md-12">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <div>
              <h1 class="fw-500 typography-headline-lg">Image Color Palette</h1>
              <p class="subtitle-1 text-muted mb-3">Upload an image and get the color palette.</p>
            </div>
          </vue-aos>
        </div>
      </div>

      <!-- IMAGE INPUT FILE -->
      <div class="row justify-content-center mb-3">
        <div class="col-md-12 col-lg-8">
          <div class="card card-outline">
            <div class="card-body text-center">
              <i class="material-icons-outlined text-gradient-animate mdc-68 mb-3">add_to_photos</i>
              <h2 class="typography-headline-sm fw-500">Upload an image</h2>
              <p class="subtitle-1 text-muted mb-3">.jpg, .jpeg, .png & .gif</p>
              <InputFile label="Image" id="image-color-picker" v-model="imageFile"></InputFile>
            </div>
          </div>

        </div>
      </div>

      <!-- COLOR PALETTE SHOWCASE -->
      <div class="row justify-content-center mb-3">
        <div class="col-md-12 col-lg-8 text-center">
          <div class="card card-no-border" id="image-palette">
            <div class="card-header card-background-image" :style="{ backgroundImage: 'url(' + imageBase64 + ')'}">
            </div>
            <div class="card-footer p-0">
              <div class="row g-1">
                <div class="col-6 col-md-2" v-for="(p,i) in palette" :key="i">
                  <div class="card card-no-border border-radius-4 palette-color-scheme"
                       :style="`background-color: rgb(${p[0]},${p[1]},${p[2]})`">
                    <div class="card-body d-flex text-center">
                      <p class="subtitle-1 align-self-center align-content-center w-100 mb-0" v-if="hideColorsText">
                        rgb({{ p[0] }}, {{ p[1] }}, {{ p[2] }})
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mb-5">
        <div class="col-md-12 col-lg-8">
          <div>
            <label class="switch">
              <input type="checkbox" id="checkHideColors" v-model="hideColorsText">
              <span class="slider round"></span>
            </label>
            <label v-if="hideColorsText === true" class="switch-label align-content-md-start ms-3"
                   for="checkHideColors">Hide
              colors text</label>
            <label v-else class="switch-label align-content-md-start ms-3" for="checkHideColors">Show colors
              text</label>
          </div>
          <!-- DOWNLOAD BUTTON -->
          <button class="btn btn-fab m-0" @click="downloadPalette"><i
              class="material-icons-outlined btn-fab-icon">download</i>
          </button>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import InputFile from "@/components/forms/InputFile";
import ColorThief from 'colorthief'
import VueAos from 'vue-aos'
import * as htmlToImage from 'html-to-image';

export default {
  name: 'ColorImagePicker',
  metaInfo: {
    title: 'Image Color Palette',
  },
  components: {InputFile, Footer, Navbar, VueAos},
  data() {
    return {
      imageFile: '',
      palette: [],
      imageBase64: '',
      hideColorsText: false,
    }
  },
  watch: {
    imageFile: {
      handler(img) {
        if (!img) {
          return
        }
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () =>
            this.imageBase64 = reader.result
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      }
    },
    imageBase64: {
      handler(img) {
        if (!img) {
          return
        }
        const image = new Image
        image.onload = () => {
          const colorThief = new ColorThief()
          this.palette = colorThief.getPalette(image, 6)

          return this.palette
        }
        image.src = img
      }
    }
  },
  methods: {
    downloadPalette() {
      htmlToImage.toJpeg(document.getElementById('image-palette'), {quality: 1})
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = 'palette.jpeg';
            link.href = dataUrl
            link.click();
          })
    },
  }
}
</script>